module.exports = __webpack_public_path__ + "static/media/icon-users-hover.53110957.svg";